import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link as RouterLink } from 'react-router-dom'
import { theme as newTheme } from 'styles/theme/hav-theme'

interface LinkStyledProps {
  disabled?: boolean
}

export const RouterLinkStyled = styled(RouterLink)<LinkStyledProps>`
  color: ${newTheme.colors.primary.main};
  font-size: ${newTheme.typography.sizes.xs};
  font-family: ${newTheme.typography.family.primary};
  font-weight: ${newTheme.typography.weight.md};

  :hover,
  :focus {
    color: ${newTheme.colors.primary.hover};
  }

  ${({ disabled }) =>
    !disabled
      ? css`
          color: ${newTheme.colors.primary.main};
          cursor: pointer;
        `
      : css`
          color: ${newTheme.colors.neutral.lighthover};
          cursor: no-drop;
          &:hover {
            color: ${newTheme.colors.neutral.lighthover};
            cursor: no-drop;
          }
        `}
`

export const ExternalLinkStyled = styled.a<LinkStyledProps>`
  font-size: ${newTheme.typography.sizes.xs};
  font-family: ${newTheme.typography.family.primary};
  font-weight: ${newTheme.typography.weight.md};

  ${({ disabled }) =>
    !disabled
      ? css`
          color: ${newTheme.colors.primary.main};
          cursor: pointer;
        `
      : css`
          color: ${newTheme.colors.neutral.lighthover};
          pointer-events: none;
        `}
`
